<template>
  <div id="webApp" class="webApp">
    <router-view class="wzPage" />
  </div>
</template>
<style>
.webApp {
  position: relative;
  top:0;
  left:0;
  overflow-x: hidden;
}
</style>
<script>
  import {mapState, mapGetters} from 'vuex'
  export default {
    computed: {
      ...mapState('config', ['navTabs']),
      ...mapGetters('nav', ['tabIndex']),
      ...mapGetters(['myUid','myLogo','myNick']),
    }
  }
</script>
